import { arrayIsEmpty } from 'utils/storeUtils'
import actions from 'actions/index'
import * as apiRequests from 'utils/apiRequest'

export default type => async (dispatch, getState) => {
  const storeData = getState()[type][type]
  if (arrayIsEmpty(storeData)) {
    const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1)
    const apiData = await apiRequests[`get${capitalizedType}`]()
    if (apiData) {
      dispatch(actions[`set${capitalizedType}`](apiData))
      return apiData
    }
  } else {
    return storeData
  }
}



// WEBPACK FOOTER //
// ./src/utils/handlerUtils.js